<mat-card class="h-100">
  <mat-card-content style="min-height: 460px">
    <h4 class="mb-20 fw-bold">{{'SCHOOL_PROGRAM_INFORMATION'|translate}}</h4>
      <div class="max-width">
          <div class="form-group row">
              <!-- First Column: Select School Level Relation -->
              <div class="col-md-6">
                  <app-select-school-level-relation-v2
                          (schoolLevelRelationChanged)="onChangeSchoolLevelRelation($event)"
                          [academic_year]="academic_year ?? null"
                          [all]="false"
                          [isDisabled]="!academic_year">
                  </app-select-school-level-relation-v2>
              </div>

              <div class="col-md-6">
                  <app-select-school-program
                          (schoolProgramChanged)="onChangeSchoolProgram($event)"
                          [school_location_id]="paramForm.get('school_location_id')?.value"
                          [isDisabled]="!paramForm.get('school_location_id')?.value">
                  </app-select-school-program>
              </div>
          </div>
          <div class="row">
              <div class="col-md-6">
                  <app-select-school-activity
                          [academic_year]="academic_year"
                          (schoolActivityChanged)="onChangeSchoolProgramActivity($event)"
                          [school_program_id]="paramForm.get('school_program_id')?.value"
                          [isDisabled]="!paramForm.get('school_program_id')?.value">
                  </app-select-school-activity>
              </div>
          </div>
      </div>

      <div *ngIf="!hasData && !loading"  class="d-flex justify-content-center align-items-center mt-5 mb-5" style="height:30vh">
          <h3>{{'NO_DATA_AVAILABLE'|translate}}</h3>
      </div>
      <div *ngIf="!hasData && loading" class="d-flex justify-content-center align-items-center mb-5" style="margin-top: 125px">
          <mat-spinner></mat-spinner>
      </div>
      <div id="chart" style="margin-top: 30px" *ngIf="hasData && !loading">
          <apx-chart
                  [series]="chartOptions.series"
                  [chart]="chartOptions.chart"
                  [dataLabels]="chartOptions.dataLabels"
                  [plotOptions]="chartOptions.plotOptions"
                  [xaxis]="chartOptions.xaxis"
                  [stroke]="chartOptions.stroke"
                  [fill]="chartOptions.fill"
                  [yaxis]="chartOptions.yaxis"
                  [title]="chartOptions.title"
                  [tooltip]="chartOptions.tooltip"
                  [legend]="chartOptions.legend"
          ></apx-chart>
      </div>
      <div id="chartD" style="margin-left: 30px" *ngIf="hasDataAttendance && !loading">
          <apx-chart
                  [series]="donutOptions.series"
                  [chart]="donutOptions.chart"
                  [labels]="donutOptions.labels"
                  [responsive]="donutOptions.responsive"
          ></apx-chart>
      </div>
  </mat-card-content>
</mat-card>
